import React from "react";

import { Select } from "antd";
import PropTypes from "prop-types";
import Spin from "shared/components/Spin";

import FloatLabel from "./FloatingLabel";

import "./style.scss";

const { Option, OptGroup } = Select;

const SelectGroup = ({ placeholder, items, loading, ...rest }) => {
  return (
    <FloatLabel className="container--input" label={placeholder} {...rest}>
      <Select
        notFoundContent={loading ? <Spin size="small" /> : null}
        showSearch
        className="select_group__custom"
        size="large"
        {...rest}>
        {Object.keys(items).map((key) => (
          <OptGroup key={`group-select:${key}`} label={key}>
            {items[key].map((item) => (
              <Option key={`option-select:${item.value}`} value={item.value}>
                {item.label}
              </Option>
            ))}
          </OptGroup>
        ))}
      </Select>
    </FloatLabel>
  );
};

SelectGroup.propTypes = {
  placeholder: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  items: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

SelectGroup.defaultProps = {
  placeholder: "",
};

export default SelectGroup;
